import React from 'react';
import { LayoutDashboard, ShoppingCart, ArrowRightLeft, Users, Wallet, FileText, Palette, Store, Share2, Grid, PlusCircle, BarChart3, Settings, LogOut, Activity, Tag } from 'lucide-react';
interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onLogout: () => void;
}
export function Sidebar({
  activeTab,
  setActiveTab,
  onLogout
}: SidebarProps) {
  const menuItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard,
    section: 'Primary'
  }, {
    id: 'orders',
    label: 'Orders',
    icon: ShoppingCart,
    section: 'Primary'
  }, {
    id: 'transactions',
    label: 'Transactions',
    icon: ArrowRightLeft,
    section: 'Primary'
  }, {
    id: 'customers',
    label: 'Customers',
    icon: Users,
    section: 'Primary'
  }, {
    id: 'financials-header',
    label: 'Financials',
    isHeader: true
  }, {
    id: 'payouts',
    label: 'Payouts',
    icon: Wallet,
    section: 'Financials'
  }, {
    id: 'pricing',
    label: 'Pricing',
    icon: Tag,
    section: 'Financials'
  }, {
    id: 'invoicing',
    label: 'Invoicing',
    icon: FileText,
    section: 'Financials'
  }, {
    id: 'growth-header',
    label: 'Growth & Branding',
    isHeader: true
  }, {
    id: 'brand-hub',
    label: 'Brand Hub',
    icon: Palette,
    section: 'Growth'
  }, {
    id: 'storefront',
    label: 'Storefront',
    icon: Store,
    section: 'Growth'
  }, {
    id: 'affiliates',
    label: 'Affiliates',
    icon: Share2,
    section: 'Growth'
  }, {
    id: 'tools-header',
    label: 'Tools',
    isHeader: true
  }, {
    id: 'app-center',
    label: 'App Center',
    icon: Grid,
    section: 'Tools'
  }, {
    id: 'add-product',
    label: 'Add Product',
    icon: PlusCircle,
    section: 'Tools'
  }, {
    id: 'reports',
    label: 'Reports',
    icon: BarChart3,
    section: 'Tools'
  }];
  return <div className="w-64 h-screen bg-slate-900 text-slate-300 flex flex-col fixed left-0 top-0 border-r border-slate-800" data-id="element-34">
      <div className="p-6 flex items-center gap-3" data-id="element-35">
        <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center" data-id="element-36">
          <span className="text-white font-bold text-xl" data-id="element-37">N</span>
        </div>
        <span className="font-bold text-white text-lg tracking-tight" data-id="element-38">
          NiishEngine
        </span>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-2 space-y-1" data-id="element-39">
        {menuItems.map(item => {
        if (item.isHeader) {
          return <div key={item.id} className="pt-6 pb-2 px-2 text-[10px] font-bold uppercase tracking-wider text-slate-500" data-id="element-40">
                {item.label}
              </div>;
        }
        const Icon = item.icon!;
        const isActive = activeTab === item.id;
        return <button key={item.id} onClick={() => setActiveTab(item.id)} className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-all duration-200 group ${isActive ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-900/20' : 'hover:bg-slate-800 hover:text-white'}`} data-id="element-41">
              <Icon size={18} className={isActive ? 'text-white' : 'text-slate-400 group-hover:text-slate-200'} data-id="element-42" />
              <span className="text-sm font-medium" data-id="element-43">{item.label}</span>
            </button>;
      })}
      </div>

      <div className="p-4 border-t border-slate-800 space-y-1" data-id="element-44">
        <button className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-800 text-slate-400 hover:text-white transition-colors" data-id="element-45">
          <Settings size={18} data-id="element-46" />
          <span className="text-sm font-medium" data-id="element-47">Settings</span>
        </button>
        <button onClick={onLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-900/20 text-slate-400 hover:text-red-400 transition-colors" data-id="element-48">
          <LogOut size={18} data-id="element-49" />
          <span className="text-sm font-medium" data-id="element-50">Logout</span>
        </button>
      </div>
    </div>;
}